import React from "react";
import {env} from "../../env";
import {getFirstLabel} from "../../constants/lotto5";


function Lotto5HistoryRows({numberItems}) {
    return (<>
        {numberItems?.map((rowNum, i) => (<tr key={i}>
            {rowNum?.map((col, j) => {
                const nums = col.split("_");
                const [range, bonus, jp] = nums;
                
                return <td
                    key={j}
                    className={`position-relative`}
                    id={"lotto5-history-key" + j}
                    width="5%"
                >
                    {range && range.length > 0 ? (<span
                        className={"position-relative overflow-hide statistic-ball-" + range + " statistic-ball-" + env.PLATFORM_FOR + "-" + range}
                    >
                                    {getFirstLabel(range)}
                        {jp > 0 && <div className="lotto5-jp-plus">+{jp}
                        </div>}

                        {bonus !== "NONE" && <div className={`lotto5-bonus statistic-ball-${bonus}`}>
                        </div>}
                                </span>) : (<span></span>)}
                </td>
            })}
        </tr>))}
    </>);
}

export default Lotto5HistoryRows;
